import find from 'lodash/find';
import decode from 'unescape';

const emptyAnswerTextSamples = [
  '<div>&nbsp;</div>',
  '&lt;div&gt;&amp;nbsp;&lt;/div&gt;',
  '<div id="bubble-rt-1">&nbsp;</div>',
  '&lt;div id="bubble-rt-1"&gt;&amp;nbsp;&lt;/div&gt;',
  '<div id="bubble-pl-1">&nbsp;</div>',
  '&lt;div id="bubble-pl-1"&gt;&amp;nbsp;&lt;/div&gt;'
];

export default function detectEmptyAnswer(text) {
  const decodedText = decode(text);
  const isEmptyAnswer = find(emptyAnswerTextSamples, emptyText => emptyText === decodedText);

  return Boolean(isEmptyAnswer);
}
